export default {
  systemTemplate: '系統模板',
  myTemplate: '我的模板',
  customCreate: '自定義創建',
  newTemplate: '新建模板',
  emptyMyTemplate: '暫無模板',
};
